import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { Observable, from, of, map } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CacheService } from '../services/cache.service';

@Injectable()
export class ApiCacheInterceptor implements HttpInterceptor {
  constructor(private cacheService: CacheService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cacheEnabledHeader = req.headers.get('enable-cache');
    if (cacheEnabledHeader) {
      const cacheTtl = req.headers.get('cache-ttl');
      req = req.clone({
        headers: req.headers.delete('cache-ttl').delete('enable-cache'),
      });
      const index = this.cacheService.makeRequestUrlIndex(req);
      return from(this.cacheService.getFromCache(index)).pipe(
        switchMap((cachedData) => {
          if (cachedData) {
            return of(new HttpResponse({ body: cachedData }));
          } else {
            return next.handle(req).pipe(
              map((res) => {
                this.cacheService.addToCache(index, (res as any).body, Number(cacheTtl));
                return res;
              }),
            );
          }
        }),
      );
    } else {
      return next.handle(req);
    }
  }
}
